import React from 'react';
import { Switch, Redirect, Route, Link, withRouter } from 'react-router-dom';
import Scenes from '../../../components/scenes/scenes';
import StarList from '../starList/starList';
import ExchangeModal from '../ExchangeModal';
import StarInstruction from '../starInstruction/starInstruction';
import styles from './home.module.scss';
// import { Commun } from '../../../utils/axios';
class Home extends React.Component {
  homeRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      ScenesShow: true,
      starListShow: false,
      starInstructionShow: false,
      exchangeModalShow: false
    }
  }
  componentDidMount() {
  }

  showDynamic = (target) => {
    this.setState({
      ScenesShow: true,
      starListShow: false,
      starInstructionShow: false,
      exchangeModalShow: false,
      ...target
    })
  }

  closePage = () => {
    // Commun.sendClient('closeStarPage', '');
  }


  render() {
    const { ScenesShow, starListShow, exchangeModalShow, starInstructionShow } = this.state;
    return (
      <div className={styles.home} id="home">
        {/* <div className={styles.closePage} onClick={() => this.closePage()}></div> */}
        {ScenesShow && <Scenes showDynamic={this.showDynamic} />}
        {starListShow && <StarList showDynamic={this.showDynamic} />}
        {starInstructionShow && <StarInstruction showDynamic={this.showDynamic} />}
        {/* 星星兑换弹窗 */}
        {
          exchangeModalShow && <ExchangeModal showDynamic={this.showDynamic}/>
        }
      </div>
    )
  }
}
export default Home;